import { CustomEventName } from '@/constants';
import { pushEvent, resetGTMDataLayer } from '..';

export const gtmTrackingWidget = (): void => {
  resetGTMDataLayer();
  pushEvent(CustomEventName.ParcelsTracked);
};
